import { AxiosInstance } from 'axios';

const CompanyServiceFactory = ({ HTTPProfileManager }: { HTTPProfileManager: AxiosInstance }) => {
  return {
    getCompanyUsers: (id: string): Promise<any[]> =>
      HTTPProfileManager.get(`companies/${id}/users`).then((res) => res.data),
  };
};

export default CompanyServiceFactory;
